import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.notifications')
  .filter('bringozTag', bringozTagCtrl);

/* @ngInject */
function bringozTagCtrl($filter) {
  return function bringozTagFilter(text, tags) {
    if (_.isUndefined(text)) {
      return;
    }

    _.forEach(tags, (tag) => {
      const tagString = '\\{' + tag.key + '\\}';
      // tagString = tagString.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      const regex = new RegExp(tagString, 'g');
      text = text.replace(regex, $filter('translate')('SMS_TEXT_TAGS.' + tag.key));
      // text = text.replace(regex, tag.previewValue[language]);
    });

    return text;
  };
}
